document.addEventListener("DOMContentLoaded", () => {
  collection.init();
});

if (document.querySelector(".engoj-collection-sidebar")) {
  window.onpopstate = () => {
    if (!collection.filterClicked) {
      collection.filterParams();
      const newurl = collection.filterCreateUrl();
      collection.filterGetContent(newurl);
      collection.resetFilter();
    }
    collection.filterClicked = false;
  };
}

const collection = {
  filterClicked: false,

  init() {
    if (!document.querySelector(".engoj-collection-sidebar")) return;

    this.filterParams();
    this.bindFilterEvents();
    this.filterMapClear();
    this.bindClearAllEvents();
  },

  filterParams() {
    Shopify.queryParams = {};
    const params = new URLSearchParams(window.location.search);
    for (const [key, value] of params) {
      Shopify.queryParams[key] = value;
    }
  },

  filterCreateUrl(baseLink) {
    const newQuery = new URLSearchParams(Shopify.queryParams).toString().replace(/%2B/g, '+');
    if (baseLink) {
      return newQuery ? `${baseLink}?${newQuery}` : baseLink;
    }
    return `${location.pathname}${newQuery ? '?' + newQuery : ''}`;
  },

  filterAjaxClick(baseLink) {
    delete Shopify.queryParams.page; // page reset on filter change
    const newurl = this.filterCreateUrl(baseLink);
    this.filterClicked = true;
    history.pushState({ param: Shopify.queryParams }, '', newurl);
    this.filterGetContent(newurl);
  },

  filterGetContent(newurl) {
    showPopup('.loading');

    fetch(newurl)
      .then(response => {
        if (!response.ok) {
          return response.json().then(err => { throw err; });
        }
        return response.text();
      })
      .then(data => {
        this.filterMapData(data);
        this.filterMapClear();
        hidePopup('.loading');
        if (typeof selectStyleCollection === 'function') selectStyleCollection();
      })
      .catch(error => {
        hidePopup('.loading');
        const errorMessage = document.querySelector('.ajax-error-message');
        if (errorMessage) {
          errorMessage.textContent = error.description || 'An error occurred';
        }
        showPopup('.ajax-error-modal');
      });
  },

  filterMapData(data) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, 'text/html');

    const currentList = document.querySelector(".grid-uniform");
    const newList = doc.querySelector(".grid-uniform");
    if (currentList && newList) currentList.replaceWith(newList);

    const oldPagi = document.querySelector(".pagi-nav");
    const newPagi = doc.querySelector(".pagi-nav");
    if (oldPagi && newPagi) oldPagi.replaceWith(newPagi);

    const oldFilters = document.querySelector(".filter-blocks");
    const newFilters = doc.querySelector(".filter-blocks");
    if (oldFilters && newFilters) oldFilters.replaceWith(newFilters);
  },

  filterMapClear() {
    document.querySelectorAll(".filter-tag").forEach(filterTag => {
      const checkedInputs = filterTag.querySelectorAll("input:checked");
      const clearBtn = filterTag.querySelector(".clear");
      if (clearBtn) {
        clearBtn.style.display = checkedInputs.length > 0 ? "block" : "none";
      }
    });
  },

  resetFilter() {
    document.querySelectorAll(".filter-custom .active, .filter-links .active").forEach(el => el.classList.remove("active"));
    document.querySelectorAll(".filter-tag input:checked").forEach(input => input.checked = false);

    const catMatch = location.pathname.match(/\/collections\/([^\/\?]+)/);
    if (catMatch && catMatch[0]) {
      const activeLink = document.querySelector(`.filter-links a[href='${catMatch[0]}']`);
      if (activeLink) activeLink.classList.add("active");
    }
  },

  bindFilterEvents() {
    document.body.addEventListener('click', e => {
      const target = e.target.closest('.filter-tag a:not(.clear), .filter-tag label');
      if (!target) return;

      e.preventDefault();

      target.classList.toggle('active');

      // Get current tags array
      let currentTags = Shopify.queryParams.constraint ? Shopify.queryParams.constraint.split('+') : [];

      const input = target.previousElementSibling;
      const tagName = input?.value;

      // Single choice filter logic, optional
      if (!window.filter_mul_choice && !input?.checked) {
        const otherChecked = target.closest('.filter-tag').querySelector("input:checked");
        if (otherChecked && otherChecked.value) {
          const idx = currentTags.indexOf(otherChecked.value);
          if (idx >= 0) currentTags.splice(idx, 1);
        }
      }

      if (tagName) {
        const idx = currentTags.indexOf(tagName);
        if (idx >= 0) {
          currentTags.splice(idx, 1);
        } else {
          currentTags.push(tagName);
        }
      }

      Shopify.queryParams.constraint = currentTags.length ? currentTags.join('+') : undefined;

      this.filterAjaxClick();
    });
  },

  bindClearAllEvents() {
    document.body.addEventListener('click', e => {
      // Clear all filters
      const clearAll = e.target.closest('.refined-widgets a.clear-all');
      if (clearAll) {
        e.preventDefault();
        delete Shopify.queryParams.constraint;
        delete Shopify.queryParams.q;
        this.filterAjaxClick();
        return;
      }

      // Clear single filter block
      const clearSingle = e.target.closest('.filter-block .clear');
      if (clearSingle) {
        e.preventDefault();
        const filterTag = clearSingle.closest('.filter-tag');
        if (!filterTag) return;

        let currentTags = Shopify.queryParams.constraint ? Shopify.queryParams.constraint.split('+') : [];

        filterTag.querySelectorAll("input:checked").forEach(input => {
          const tagName = input.value;
          const idx = currentTags.indexOf(tagName);
          if (idx >= 0) currentTags.splice(idx, 1);
        });

        filterTag.querySelectorAll("a").forEach(a => a.classList.remove("active"));

        Shopify.queryParams.constraint = currentTags.length ? currentTags.join('+') : undefined;

        this.filterAjaxClick();
      }
    });
  }
};
